import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#F1F4FA"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path fill="#C7D0D9" d="M42.5 18a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M24.06 1.94a1.5 1.5 0 0 1 0 2.12l-10 10a1.5 1.5 0 0 1-2.12-2.12l10-10a1.5 1.5 0 0 1 2.12 0"
      clipRule="evenodd"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M11.94 1.94a1.5 1.5 0 0 1 2.12 0l10 10a1.5 1.5 0 0 1-2.12 2.12l-10-10a1.5 1.5 0 0 1 0-2.12"
      clipRule="evenodd"
    />
    <path fill="#ACB8C3" d="M108.5 39a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M57 70.5a1.5 1.5 0 0 1 1.5 1.5v14a1.5 1.5 0 0 1-3 0V72a1.5 1.5 0 0 1 1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M48.5 78.999a1.5 1.5 0 0 1 1.5-1.5h14a1.5 1.5 0 0 1 0 3H50a1.5 1.5 0 0 1-1.5-1.5M108 75a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6 4a6 6 0 1 1 12 0 6 6 0 0 1-12 0"
      clipRule="evenodd"
    />
    <path
      fill="#8F9BA8"
      d="M93.114 23.001H14.79c-1.801 0-3.528.71-4.802 1.973A6.71 6.71 0 0 0 8 29.739v20.213c0 3.721 3.04 6.737 6.79 6.737h55.638L95.97 23.932a4.87 4.87 0 0 0-2.857-.93"
    />
    <mask
      id="enrichedIcon-MeasureGreyscale_svg__a"
      width={90}
      height={34}
      x={8}
      y={23}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        d="M98 23.001H14.79c-1.801 0-3.528.71-4.802 1.973A6.71 6.71 0 0 0 8 29.739v20.213c0 3.721 3.04 6.737 6.79 6.737h56.046z"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M95.91 24.001H14.79a5.82 5.82 0 0 0-4.098 1.683A5.7 5.7 0 0 0 9 29.738v20.213c0 3.161 2.585 5.737 5.79 5.737h55.568zm-81.12-1c-1.801 0-3.528.71-4.802 1.973A6.71 6.71 0 0 0 8 29.739v20.213c0 3.721 3.04 6.737 6.79 6.737h56.046L98 23.002z"
        clipRule="evenodd"
      />
    </mask>
    <g
      fill="#7B8493"
      fillRule="evenodd"
      clipRule="evenodd"
      mask="url(#enrichedIcon-MeasureGreyscale_svg__a)"
    >
      <path d="M21.603 44.334a2.25 2.25 0 0 1 2.25 2.25v10.107a2.25 2.25 0 1 1-4.5 0V46.584a2.25 2.25 0 0 1 2.25-2.25M41.975 44.334a2.25 2.25 0 0 1 2.25 2.25v10.107a2.25 2.25 0 1 1-4.5 0V46.584a2.25 2.25 0 0 1 2.25-2.25M62.348 44.334a2.25 2.25 0 0 1 2.25 2.25v10.107a2.25 2.25 0 1 1-4.5 0V46.584a2.25 2.25 0 0 1 2.25-2.25M31.789 20.751a2.25 2.25 0 0 1 2.25 2.25v10.107a2.25 2.25 0 1 1-4.5 0V23a2.25 2.25 0 0 1 2.25-2.25M52.162 20.751a2.25 2.25 0 0 1 2.25 2.25v10.107a2.25 2.25 0 1 1-4.5 0V23a2.25 2.25 0 0 1 2.25-2.25M72.534 20.751a2.25 2.25 0 0 1 2.25 2.25v10.107a2.25 2.25 0 1 1-4.5 0V23a2.25 2.25 0 0 1 2.25-2.25" />
    </g>
    <path
      fill="#ACB8C3"
      d="M95.97 23.932 70.429 56.689h.409v39.574c0 3.72 3.04 6.737 6.79 6.737h13.582c3.75 0 6.79-3.016 6.79-6.737V27.849c0-1.616-.805-3.037-2.028-3.917"
    />
  </svg>
);
const SvgEnrichedIconMeasureGreyscale = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconMeasureGreyscale);
export default Memo;
